<template>
  <div class="editPets">
    <div class="editPets__tabs">
      <button :class="{ selected: tabToggle === 'add' }" @click="selectTab('add')">Добавить</button>
      <button :class="{ selected: tabToggle === 'edit' }" @click="selectTab('edit')">
        Редактировать
      </button>
      <button :class="{ selected: tabToggle === 'description' }" @click="selectTab('description')">
        Описание
      </button>
    </div>
    <div class="formWrapper" v-if="tabToggle === 'add'">
      <div class="pet__form">
        <div class="inputWrapper">
          <span>Name:</span>
          <input class="name" type="text" placeholder="name" v-model="formParams.name" />
        </div>
        <div class="inputWrapper">
          <span>RealName:</span>
          <input class="name" type="text" placeholder="realName" v-model="formParams.realName" />
        </div>
        <div class="inputWrapper">
          <span>Rare:</span>
          <div class="pet__form__select" @click="toggleSelect('rare')">
            <p>{{ formParams.rare }}</p>
            <img
              :class="{ rotate: selectsOpen.rare }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.rare" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.rare"
              :key="key"
              v-if="type !== formParams.rare"
              @click="selectValue('rare', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="inputWrapper">
          <span>ItemType:</span>
          <div class="pet__form__select" @click="toggleSelect('itemType')">
            <p>{{ formParams.itemType }}</p>
            <img
              :class="{ rotate: selectsOpen.itemType }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.itemType" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.itemType"
              :key="key"
              v-if="type !== formParams.itemType"
              @click="selectValue('itemType', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="inputWrapper">
          <span>Description ID:</span>
          <input
            class="name"
            type="text"
            placeholder="description_id (необязательно)"
            v-model="formParams.descriptionId"
          />
        </div>
        <div class="inputWrapper" v-if="formParams.itemType === 'transport'">
          <span>Subcategory:</span>
          <div class="pet__form__select" @click="toggleSelect('transport')">
            <p>{{ formParams.transport }}</p>
            <img
              :class="{ rotate: selectsOpen.transport }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.transport" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.transport"
              :key="key"
              v-if="type !== formParams.type"
              @click="selectValue('transport', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="pet__form__file">
          <input
            name="file"
            id="file"
            type="file"
            accept=".png"
            class="input__file"
            @change="loadFile"
            :value="inputFileValue"
          />
          <label for="file"> Загрузить файл </label>
          <div class="pet__form__file__img" v-if="formParams.img">
            <img :src="loadedImg" />
            <p>{{ formParams.img.name.replace('.png', '') }}</p>
          </div>
        </div>
        <div class="pet__form__submit">
          <button :class="{ disable: isBtnDisable }" @click="loadNewPet">Добавить</button>
          <p
            v-if="formParams.img && formParams.img.name.replace('.png', '') !== formParams.realName"
          >
            Название картинки должно совпадать с RealName
          </p>
        </div>
        <p class="pet__form__success" v-if="responseSuccess">Успешно !</p>
      </div>
    </div>
    <div class="formWrapper" v-if="tabToggle === 'edit'">
      <div class="pet__form" v-if="!foundPet">
        <div class="inputWrapper">
          <span>Имя пета:</span>
          <input class="name" type="text" placeholder="name" v-model="searchPet" />
        </div>
        <div class="pet__form__submit">
          <Loader v-if="loader" />
          <button v-else @click="findPet" :class="{ disable: !searchPet }">Найти</button>
          <span v-if="errorMsg">Питомец не был найден</span>
        </div>
      </div>
      <div class="pet__form" v-if="foundPet">
        <div class="inputWrapper">
          <span>Name:</span>
          <input class="name" type="text" placeholder="name" v-model="editFoundPet.name" />
        </div>
        <div class="inputWrapper">
          <span>RealName:</span>
          <input class="name" type="text" placeholder="realName" v-model="editFoundPet.realName" />
        </div>
        <div class="inputWrapper">
          <span>Rare:</span>
          <div class="pet__form__select" @click="toggleSelect('rare')">
            <p>{{ editFoundPet.rare }}</p>
            <img
              :class="{ rotate: selectsOpen.rare }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.rare" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.rare"
              :key="key"
              v-if="type !== formParams.rare"
              @click="selectValue('rare', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="inputWrapper">
          <span>ItemType:</span>
          <div class="pet__form__select" @click="toggleSelect('itemType')">
            <p>{{ editFoundPet.itemType }}</p>
            <img
              :class="{ rotate: selectsOpen.itemType }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.itemType" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.itemType"
              :key="key"
              v-if="type !== editFoundPet.itemType"
              @click="selectValue('itemType', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="inputWrapper">
          <span>Description ID:</span>
          <input
            class="name"
            type="text"
            placeholder="description_id (необязательно)"
            v-model="editFoundPet.descriptionId"
          />
        </div>
        <div class="inputWrapper">
          <span>Доступный:</span>
          <div class="pet__form__select" @click="toggleSelect('availableItem')">
            <p>
              {{ editFoundPet.availableItem ? 'Да' : 'Нет' }}
            </p>
            <img
              :class="{ rotate: selectsOpen.availableItem }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.availableItem" class="pet__form__selectDropDown">
            <span @click="selectValue('availableItem', true)"> Да </span>
            <span @click="selectValue('availableItem', false)"> Нет </span>
          </div>
        </div>
        <div class="inputWrapper" v-if="editFoundPet.itemType === 'transport'">
          <span>Subcategory:</span>
          <div class="pet__form__select" @click="toggleSelect('transport')">
            <p>{{ editFoundPet.transport }}</p>
            <img
              :class="{ rotate: selectsOpen.transport }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.transport" class="pet__form__selectDropDown">
            <span
              v-for="(type, key) in selects.transport"
              :key="key"
              v-if="type !== editFoundPet.transport"
              @click="selectValue('transport', type)"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="pet__form__img"></div>
        <div class="pet__form__file">
          <input
            name="file"
            id="file"
            type="file"
            accept=".png"
            class="input__file"
            @change="loadFile"
            :value="inputFileValue"
          />
          <label for="file"> Загрузить файл </label>
          <div class="pet__form__file__img">
            <img :src="editFoundPet.img" alt="img" />
            <p v-if="formParams.img">{{ formParams.img.name.replace('.png', '') }}</p>
          </div>
        </div>
        <div class="pet__form__submit">
          <button :class="{ disable: isEditBtnDisable }" @click="editPet">Редактировать</button>
          <p
            v-if="
              formParams.img && formParams.img.name.replace('.png', '') !== editFoundPet.realName
            "
          >
            Название картинки должно совпадать с RealName
          </p>
        </div>
        <p class="pet__form__success" v-if="responseSuccess">Успешно !</p>
      </div>
    </div>
    <div class="formWrapper" v-if="tabToggle === 'description'">
      <div class="pet__form" v-if="!description.found">
        <div class="inputWrapper">
          <span>Real name:</span>
          <input class="name" type="text" placeholder="real name" v-model="description.petName" />
        </div>
        <div class="pet__form__submit">
          <button :class="{ disable: !description.petName }" @click="getAllPetDescription">
            Найти
          </button>
        </div>
      </div>
      <div class="pet__form" v-else>
        <div class="inputWrapper">
          <span>Language:</span>
          <div class="pet__form__select" @click="toggleSelect('description')">
            <p>{{ description.selectedLang }}</p>
            <img
              :class="{ rotate: selectsOpen.description }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div v-if="selectsOpen.description" class="pet__form__selectDropDown">
            <span
              v-for="(value, key) in description.lang"
              :key="key"
              v-if="key !== description.selectedLang"
              @click="selectLang(key)"
            >
              {{ key }}
            </span>
          </div>
        </div>
        <div class="pet__form__description">
          <p class="pet__form__description__name">
            Real name: <span>{{ description.petName }}</span>
          </p>
          <textarea
            v-model="description.lang[description.selectedLang]"
            :placeholder="`Описание товара на ${description.selectedLang} языке`"
          />
          <div class="pet__form__submit">
            <button
              :class="{ disable: !description.lang[description.selectedLang] }"
              @click="setPetDescription(description.selectedLang)"
            >
              Сохранить {{ description.selectedLang }} язык
            </button>
          </div>
          <p class="editPets__success" v-if="description.success">
            {{ description.selectedLang }} язык сохранен
          </p>
          <p class="editPets__error" v-if="description.error">Ошибка {{ description.error }}</p>
        </div>
      </div>
    </div>
    <input class="editPets__twoFA" type="text" placeholder="Two-factor" v-model="twoFA" />
    <button :class="{ editPets__update: true, disable: !twoFA }" @click="updateDataBase">
      Обновить версию гудсов
    </button>
    <p v-if="updateDataBaseSuccess" class="editPets__success">База обновлена !</p>
    <p v-if="twoFAError" class="editPets__error">Неверный 2FA либо нет прав !</p>
  </div>
</template>

<script>
import './editPets.scss'

import Loader from '../../components/Loader/Loader'
import cookie from 'vue-cookie'

export default {
  name: 'EditPets',
  components: { Loader },
  data() {
    return {
      tabToggle: 'add',
      searchPet: '',
      twoFA: '',
      formParams: {
        name: '',
        realName: '',
        rare: 'Выберите редкость',
        itemType: 'Выберите тип',
        transport: 'Выберите тип транспорта',
        img: '',
        descriptionId: ''
      },
      loadedImg: '',
      responseImgId: '',
      responseSuccess: false,
      twoFAError: false,
      updateDataBaseSuccess: false,
      inputFileValue: '',
      selects: {
        rare: {
          common: 'common',
          uncommon: 'uncommon',
          rare: 'rare',
          ultra_rare: 'ultra_rare',
          legendary: 'legendary'
        },
        itemType: {
          pet: 'pet',
          egg: 'egg',
          potion: 'potion',
          transport: 'transport'
        },
        transport: {
          scooters: 'scooters',
          skateboards: 'skateboards',
          snowboards: 'snowboards',
          legendary_gift_vehicles: 'legendary_gift_vehicles',
          event_vehicles: 'event_vehicles',
          vehicle_dealership: 'vehicle_dealership',
          premium_vehicles: 'premium_vehicles',
          star_rewards_vehicles: 'star_rewards_vehicles',
          miscellaneous_vehicles: 'miscellaneous_vehicles'
        }
      },
      selectsOpen: {
        rare: false,
        itemType: false,
        transport: false,
        description: false,
        availableItem: false
      },
      loader: false,
      errorMsg: false,
      foundPet: null,
      editFoundPet: {
        availableItem: true,
        name: '',
        realName: '',
        rare: '',
        itemType: '',
        transport: '',
        img: '',
        descriptionId: ''
      },
      description: {
        lang: {
          ru: '',
          en: '',
          tr: '',
          pt: '',
          fr: '',
          es: '',
          it: '',
          fl: '',
          de: '',
          seo: ''
        },
        selectedLang: 'ru',
        petName: '',
        found: false,
        success: false,
        error: false
      }
    }
  },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  computed: {
    isBtnDisable() {
      if (
        this.formParams.name &&
        this.formParams.realName &&
        this.formParams.rare !== 'Выберите редкость' &&
        this.formParams.itemType !== 'Выберите тип'
      ) {
        if (this.formParams.img.name) {
          if (this.formParams.img.name?.replace('.png', '') === this.formParams.realName) {
            return false
          } else return true
        }
        if (
          this.formParams.itemType === 'transport' &&
          this.formParams.transport === 'Выберите тип транспорта'
        ) {
          return true
        }
        return false
      }
      return true
    },
    isEditBtnDisable() {
      if (
        this.editFoundPet.name !== this.foundPet.name ||
        this.editFoundPet.realName !== this.foundPet.realName ||
        this.editFoundPet.rare !== this.foundPet.rare ||
        this.editFoundPet.itemType !== this.foundPet.itemType ||
        this.responseImgId ||
        this.editFoundPet.availableItem !== this.foundPet.available_item ||
        this.editFoundPet.descriptionId !== (this.foundPet.descriptionId || '')
      ) {
        if (
          this.formParams.img &&
          this.formParams.img.name?.replace('.png', '') !== this.editFoundPet.realName
        ) {
          return true
        }
        if (
          this.editFoundPet.itemType === 'transport' &&
          this.editFoundPet.transport === 'Выберите тип транспорта'
        ) {
          return true
        }
        return false
      }
      return true
    }
  },
  methods: {
    initListeners() {
      document.addEventListener('click', this.closeByClickingOut)
    },
    closeByClickingOut(event) {
      const path = event.path || (event.composedPath && event.composedPath())

      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('pet__form__select') ||
              div.classList.contains('pet__form__selectDropDown'))
        )
      ) {
        for (let key in this.selectsOpen) {
          this.selectsOpen[key] = false
        }
      }
    },
    clearParams() {
      this.formParams = {
        name: '',
        realName: '',
        rare: 'Выберите редкость',
        itemType: 'Выберите тип',
        transport: 'Выберите тип транспорта',
        img: '',
        descriptionId: ''
      }
      this.editFoundPet = {
        name: '',
        realName: '',
        rare: '',
        itemType: '',
        transport: '',
        img: '',
        descriptionId: ''
      }
      this.foundPet = null
      this.responseImgId = ''
      this.description.petName = ''
      this.description.found = false
      for (let language in this.description.lang) {
        this.description.lang[language] = ''
      }
    },
    selectTab(key) {
      this.tabToggle = key
      this.foundPet = null
      this.clearParams()
    },
    toggleSelect(key) {
      this.selectsOpen[`${key}`] = !this.selectsOpen[`${key}`]
    },
    selectValue(key, value) {
      this.formParams[`${key}`] = value
      this.editFoundPet[`${key}`] = value
      this.selectsOpen[`${key}`] = !this.selectsOpen[`${key}`]
    },
    selectLang(lang) {
      this.description.selectedLang = lang
      this.selectsOpen.description = false
    },
    loadFile(event) {
      this.formParams.img = event.target.files[0]
      this.loadedImg = window.URL.createObjectURL(this.formParams.img)
      this.editFoundPet.img = window.URL.createObjectURL(this.formParams.img)
      this.loadImg()
    },
    async loadImg() {
      const formData = new FormData()
      formData.append('file', this.formParams.img)
      const res = await fetch('https://goods.neuralgeneration.com/api/assets/upload', {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${cookie.get('token')}` }
      })
      const data = await res.json()
      this.responseImgId = data.image_id
    },
    loadNewPet() {
      const body = {
        name: this.formParams.name,
        realName: this.formParams.realName,
        imageId: this.responseImgId,
        rare: this.formParams.rare,
        itemType: this.formParams.itemType,
        subcategory: this.formParams.itemType === 'transport' ? this.formParams.transport : null,
        availableItem: true,
        descriptionId: this.formParams.descriptionId
      }
      fetch('https://goods.neuralgeneration.com/api/goods/create_as_admin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.clearParams()
            this.responseSuccess = true
            setTimeout(() => {
              this.responseSuccess = false
            }, 2000)
          }
        })
    },
    editPet() {
      const body = {
        name: this.editFoundPet.name,
        realName: this.editFoundPet.realName,
        imageId: this.responseImgId
          ? this.responseImgId
          : this.foundPet.imageUri.split('/').pop().replace('.png', ''),
        rare: this.editFoundPet.rare,
        oldRealName: this.foundPet.realName,
        itemType: this.editFoundPet.itemType,
        subcategory:
          this.editFoundPet.itemType === 'transport' ? this.editFoundPet.transport : null,
        availableItem: this.editFoundPet.availableItem,
        descriptionId: this.editFoundPet.descriptionId
      }
      fetch('https://goods.neuralgeneration.com/api/goods/update_as_admin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.clearParams()
            this.responseSuccess = true
            setTimeout(() => {
              this.responseSuccess = false
            }, 2000)
          }
        })
    },
    updateDataBase() {
      fetch('https://goods.neuralgeneration.com/api/goods/update_version', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify({ code: this.twoFA })
      })
        .then((res) => {
          if (res.status === 403) {
            this.twoFAError = true
            setTimeout(() => {
              this.twoFAError = false
            }, 2000)
          }
          return res.json()
        })
        .then((data) => {
          if (data.status) {
            this.updateDataBaseSuccess = true
            setTimeout(() => {
              this.updateDataBaseSuccess = false
            }, 2000)
          }
        })
    },
    async findPet() {
      this.loader = true
      fetch(
        `https://goods.neuralgeneration.com/api/goods/fetch_by_name_list?nameList=${this.searchPet}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => {
          if (res.status !== 200) {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 1500)
          }
          return res.json()
        })
        .then((data) => {
          this.loader = false
          this.foundPet = data?.goods[0]
          this.editFoundPet = {
            name: data?.goods[0].name,
            realName: data?.goods[0].realName,
            rare: data?.goods[0].rare,
            itemType: data?.goods[0].itemType,
            transport: data?.goods[0].subcategory
              ? data?.goods[0].subcategory
              : 'Выберите тип транспорта',
            img: data?.goods[0].imageUri,
            availableItem: data?.goods[0].available_item,
            descriptionId: data?.goods[0].descriptionId
          }
          if (!data?.goods[0]) {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 1500)
          }
        })
    },
    getAllPetDescription() {
      Promise.all([
        this.getPetDescription('ru'),
        this.getPetDescription('en'),
        this.getPetDescription('tr'),
        this.getPetDescription('pt'),
        this.getPetDescription('fr'),
        this.getPetDescription('es'),
        this.getPetDescription('it'),
        this.getPetDescription('fl'),
        this.getPetDescription('de'),
        this.getPetDescription('seo')
      ]).then((res) => {
        this.description.found = true
      })
    },
    getPetDescription(lang) {
      return fetch(
        `https://goods.neuralgeneration.com/api/goods/fetch_description?name=${this.description.petName}&lang=${lang}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.desc) {
            this.description.lang[lang] = data.desc
          }
        })
    },
    setPetDescription(lang) {
      fetch('https://goods.neuralgeneration.com/api/goods/update_description', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify({
          name: this.description.petName,
          lang: lang,
          desc: this.description.lang[lang]
        })
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.validation_error?.body_params[0].msg) {
            this.description.error = data.validation_error.body_params[0].msg
            setTimeout(() => {
              this.description.error = false
            }, 1500)
          }
          if (data.status) {
            this.description.success = true
            setTimeout(() => {
              this.description.success = false
            }, 1000)
          }
        })
    }
  }
}
</script>
